/* eslint-disable react/require-default-props */
import { Typography } from "@mui/material"
import IconBox from "../../IconBox"
import {
  AccordionBody,
  AccordionHeader,
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailsContainerTextOverflow,
  DetailValue,
  ScrollContainer,
  StatusChecked,
  StyledAccordion,
  StyledDivider,
  TopContainer,
} from "../styled"
import UIIcon from "../../UIIcon"
import { formatAmount } from "../../../utils/formatters"
import { RUBLE } from "../../../utils/constants"
import { formatMoscowDateTime } from "../../../utils/datetime"
import { PaymentStatusResponse } from "../../../types/payments"

interface MBankPaymentHistoryDetailsProps {
  data: PaymentStatusResponse
}

const MBankPaymentHistoryDetails = ({
  data,
}: MBankPaymentHistoryDetailsProps) => {
  // const statusDetails = getOperationStatusDetails(data.status)
  const { incomeTransfer, providerPayment } = data.transactions

  const isAccepted = data.status === "Accepted"

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg">
            <UIIcon
              iconName={isAccepted ? "checkYellow" : "errorTransfer"}
              size={80}
            />
          </IconBox>
          <Typography variant="h3" fontWeight={700} textAlign="center" mt={4}>
            {isAccepted ? "Перевод выполнен" : "Перевод не выполнен"}
          </Typography>
          <Amount>
            {formatAmount(incomeTransfer?.amount || providerPayment.amount)} {RUBLE}
          </Amount>
        </TopContainer>
        <StyledDivider />

        <StyledAccordion>
          <AccordionHeader
            expandIcon={<UIIcon iconName="arrowDown" />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="h4">Подробнее об операции</Typography>
          </AccordionHeader>
          <AccordionBody>
            <DetailsContainer sx={DetailsContainerTextOverflow}>
              <DetailContainer>
                <DetailLabel>Дата и время операции</DetailLabel>
                <DetailValue>
                  {formatMoscowDateTime(data.updatedOn)}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Номер операции в РНКО «Единая касса»</DetailLabel>
                <DetailValue>{data.combinedPaymentId}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Статус операции</DetailLabel>
                <DetailValue>
                  <StatusChecked
                    // statusColor={statusDetails.color}
                    statusColor="blue"
                  >
                    {data.status === "Accepted" ? "Успешно" : "Отклонена"}
                  </StatusChecked>
                </DetailValue>
              </DetailContainer>
              {incomeTransfer && <DetailContainer>
                <DetailLabel>Сумма операции</DetailLabel>
                <DetailValue>
                  {formatAmount(incomeTransfer.amount)} {RUBLE}
                </DetailValue>
              </DetailContainer>}

              <Typography variant="h4Bold" sx={{ mt: 3, mb: 2 }}>
                Входящая операция СБП
              </Typography>

              {incomeTransfer && <>
              <DetailContainer>
                <DetailLabel>Дата и время операции СБП</DetailLabel>
                <DetailValue>
                  {formatMoscowDateTime(incomeTransfer.updatedOn)}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>
                  Идентификатор операции СБП в РНКО «Единая касса»
                </DetailLabel>
                <DetailValue>{incomeTransfer.incomeTransferId}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Состояние операции СБП</DetailLabel>
                <DetailValue>
                  {incomeTransfer.status === "Accepted"
                    ? "Успешно"
                    : "Отклонена"}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Идентификатор операции СБП</DetailLabel>
                <DetailValue>{incomeTransfer.operationNumber}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Телефон плательщика</DetailLabel>
                <DetailValue>{incomeTransfer.payer.phoneNumber}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Плательщик</DetailLabel>
                <DetailValue>{incomeTransfer.payer.pam}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Банк отправителя</DetailLabel>
                <DetailValue>{incomeTransfer.payer.bank.nameRus}</DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Сумма операции СБП</DetailLabel>
                <DetailValue>
                  {formatAmount(incomeTransfer.amount)} {RUBLE}
                </DetailValue>
              </DetailContainer>
              <DetailContainer>
                <DetailLabel>Назначение платежа</DetailLabel>
                <DetailValue>{incomeTransfer.description}</DetailValue>
              </DetailContainer>
              </>}

              {/* Пополнение счета МБанк */}
              {providerPayment && (
                <>
                  <Typography variant="h4Bold" sx={{ mt: 3, mb: 2 }}>
                    Пополнение счета МБанк
                  </Typography>

                  <DetailContainer>
                    <DetailLabel>Идентификатор операции пополнения</DetailLabel>
                    <DetailValue>
                      {providerPayment.providerPaymentId}
                    </DetailValue>
                  </DetailContainer>
                  <DetailContainer>
                    <DetailLabel>Сумма операции пополнения</DetailLabel>
                    <DetailValue>
                      {formatAmount(providerPayment.amount)} {RUBLE}
                    </DetailValue>
                  </DetailContainer>
                  <DetailContainer>
                    <DetailLabel>Дата и время операции пополнения</DetailLabel>
                    <DetailValue>
                      {formatMoscowDateTime(providerPayment.updatedOn)}
                    </DetailValue>
                  </DetailContainer>
                  <DetailContainer>
                    <DetailLabel>Состояние пополнения</DetailLabel>
                    <DetailValue>
                      {providerPayment.status === "Accepted"
                        ? "Успешно"
                        : "Отклонена"}
                    </DetailValue>
                  </DetailContainer>
                  {providerPayment.providerReturnedFields?.CurrencyRate && (
                    <DetailContainer>
                      <DetailLabel>Курс конвертации</DetailLabel>
                      <DetailValue>
                        {
                          providerPayment.providerReturnedFields
                            .CurrencyRate as string
                        }
                      </DetailValue>
                    </DetailContainer>
                  )}
                  {providerPayment.providerReturnedFields?.qid && (
                    <DetailContainer>
                      <DetailLabel>
                        Идентификатор пополнения в МБанк
                      </DetailLabel>
                      <DetailValue>
                        {providerPayment.providerReturnedFields.qid as string}
                      </DetailValue>
                    </DetailContainer>
                  )}
                  {providerPayment.providerReturnedFields?.account && (
                    <DetailContainer>
                      <DetailLabel>Номер счета</DetailLabel>
                      <DetailValue>
                        {
                          providerPayment.providerReturnedFields
                            .account as string
                        }
                      </DetailValue>
                    </DetailContainer>
                  )}
                  {providerPayment.providerReturnedFields?.CreditCurrency && (
                    <DetailContainer>
                      <DetailLabel>Валюта счета</DetailLabel>
                      <DetailValue>
                        {
                          providerPayment.providerReturnedFields
                            .CreditCurrency as string
                        }
                      </DetailValue>
                    </DetailContainer>
                  )}
                </>
              )}
            </DetailsContainer>
          </AccordionBody>
        </StyledAccordion>
      </ScrollContainer>
    </ContentContainer>
  )
}

export default MBankPaymentHistoryDetails
